/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_TitleInputs */



/**
* | output |
* | --- |
* | "Your Recovery Code" |
*
* @param {Auth_Recovery_Code_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_title = /** @type {((inputs?: Auth_Recovery_Code_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein Wiederherstellungscode")
	return /** @type {LocalizedString} */ ("Your Recovery Code")
});